import { render, staticRenderFns } from "./StaticPopup.vue?vue&type=template&id=7dff6b66&scoped=true&"
import script from "./StaticPopup.vue?vue&type=script&lang=js&"
export * from "./StaticPopup.vue?vue&type=script&lang=js&"
import style0 from "./StaticPopup.vue?vue&type=style&index=0&id=7dff6b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff6b66",
  null
  
)

export default component.exports